// Best guess for a plan line from an Accurate bank entry, so a bank-only
// row becomes an (almost) one-click "Tambah" (Director, 2 Oct: "make them
// clickable with an option to add and prefill guesses … she still can edit
// if necessary"). Everything here is only a starting point in the sheet.
import { shortDate } from './model';

const RULES_IN = [
  [/indah ?kiat/, 'Indahkiat', 'Penerimaan'],
  [/\bcan\b|citra akbar|\bcsk\b/, 'CAN', 'Penerimaan'],
  [/\blsj\b/, 'LSJ', 'Penerimaan'],
  [/aceng|yaputra/, 'Pak Aceng', 'Penerimaan'],
  [/ahmad|wirama/, 'Pak Ahmad', 'Penerimaan'],
  [/pinjaman/, 'Other', 'Pinjaman'],
];
const RULES_OUT = [
  [/waste/, 'Indahkiat', 'UJ Waste Lampung'],
  [/\b(uj|uang jalan)\b.*lampung/, 'Indahkiat', 'UJ Lampung'],
  [/\blsj\b/, 'LSJ', 'UJ Balikan'],
  [/aceng/, 'Pak Aceng', 'UJ Balikan'],
  [/ahmad/, 'Pak Ahmad', 'UJ Balikan'],
  [/\b(uj|uang jalan)\b.*\b(csk|can)\b|\b(csk|can)\b.*\b(uj|uang jalan)\b/, 'CAN', 'UJ Balikan'],
  [/pinjaman/, 'Other', 'Pinjaman'],
  [/koordinasi/, 'Other', 'Operasional'],
  [/nota|service|servis|sparepart|bengkel|lakop|\bban\b|perbaikan|leasing/, 'Other', 'Vendor'],
];

export function guessFromBank(e, legacy) {
  const d = String(e.description || '').toLowerCase();
  const inflow = e.amount > 0;
  const rules = inflow ? RULES_IN : RULES_OUT;
  const hit = rules.find(([re]) => re.test(d));
  let [customer, tipe] = hit ? [hit[1], hit[2]] : ['Other', inflow ? 'Penerimaan' : 'Operasional'];
  const type = inflow ? 'add_inflow' : 'add_disbursement';
  // Must be a tipe the Tambah sheet offers for that customer and direction.
  const opts = legacy ? legacy.addTipeOptionsFor(customer, type) : [tipe];
  if (!opts.includes(tipe)) tipe = opts[0] || tipe;
  const truk = (String(e.description).match(/\b9\d{3}\b/) || [''])[0];
  return {
    type, customer, tipe, truk,
    date: e.tanggal, amount: String(Math.abs(Math.round(e.amount))), ket: String(e.description || '').trim(),
    reason: `Sesuai bank (Accurate) ${shortDate(e.tanggal)}`,
  };
}
